import { styled } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

export const VideoUploading = styled("div")(() => ({
  height: 115,
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: 8,
  marginTop: 12,
  marginBottom: 16,
  padding: "24px 24px",
  objectFit: "fill",
  opacity: 0.7,
  position: "relative",
  background: "#F8FAFC",
}));

const styles = makeStyles(() => ({
  loading: {
    height: 115,
    marginBottom: 16,
    marginTop: 12,
  },
  titleVideo: {
    color: "#465869",
    fontSize: 16,
    fontWeight: 700,
    marginBottom: 12,
  },
  videoWrapper: {
    marginTop: 12,
  },
  videoStyle: {
    height: 115,
    width: 325,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    borderRadius: 8,
    marginBottom: 16,
    cursor: "pointer",
    objectFit: "fill",
    opacity: 0.7,
    position: "relative",
    "&.withoutVideo": {
      background: "#F8FAFC",
      cursor: "default",
      padding: "0 24px 24px",
      marginTop: 12,
      width: "100%",
    },
    "&.withAnimation": {
      animation: `$bouncing 1s ease-in-out infinite`,
    },
  },
  videoDescription: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    position: "absolute",
    bottom: "15%",
    left: "5%",
    color: "#fff",
    "& > span": {
      fontSize: 14,
      fontWeight: 500,
      fontFamily: "Manrope",
    },
  },
  videoName: {
    marginTop: 3,
  },
  uploadProgress: {
    height: 115,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    padding: "0 24px 24px",
    borderRadius: 8,
    marginBottom: 16,
    position: "absolute",
    zIndex: 99,
    objectFit: "fill",
    opacity: 0.7,
    background: "#EDEFF1",
    cursor: "default",
    animation: `$bouncing 1s ease-in-out infinite`,
  },
  "@keyframes bouncing": {
    "0%": {
      backgroundColor: "#f8fafc",
    },
    "50%": {
      backgroundColor: "#EDEFF1",
    },
    "100%": {
      backgroundColor: "#f8fafc",
    },
  },
  grid: {
    marginTop: 12,
    width: "100%",
  },
}));

export default styles;
